import * as React from 'react'
import './index.scss'
import {connect} from "react-redux";
import {
    ActionType, CHAINTYPES, reducerStoreType, ROLES, storeType, userFilterType,
    userType,
} from "../../reducers/types";
import {Dispatch} from "redux";
import UserFilters from "./UserFilters";
import UserList from "./UserList";
import Pagination from "../../components/Pagination";
import AddUserModal from "./AddUserModal";
import CustomDialog from "../../components/CustomUIComp/CustomDialog";
import {addUserReq} from "../../api/types";
import {injectIntl, IntlShape} from 'react-intl'
import md5 from "js-md5";
import {SALT_STRING} from "../../constants";

interface IProps{
    dispatch: Dispatch<ActionType<any>>,
    userList: userType[],
    storeList: storeType[],
    userFilter: userFilterType,
    total: number,
    currentPage: number,
    recordsPerPage: number,
    chainType: CHAINTYPES,
    role: ROLES,
    intl: IntlShape
}

interface IState{
    open: boolean,
    addUserForm: addUserReq,
    addUserFormErrors: {[key:string]: string}
}

const defaultAddUserForm = {
    loginNo: '',
    password: '',
    phoneNo: '',
    name: '',
    role: ROLES.NONE,
    storeId: -1
}

class Users extends React.Component<IProps, IState> {
    constructor(props: IProps){
        super(props)
        this.state = {
            open: false,
            addUserForm: defaultAddUserForm,
            addUserFormErrors: {}
        }
    }
    handleFilterChange = (object: {name: string, value: any}) => {
        this.props.dispatch({type: 'USER_FILTER_CHANGE', payload: object})
    }
    clearFilter = () => {
        this.props.dispatch({type: 'USER_FILTER_CLEAR', payload: undefined})
        this.props.dispatch({type: 'GET_USERS', payload: {pageParams:{currentPage: 1}}})
    }
    onPageChange = (page: number) => {
        this.props.dispatch({type: 'GET_USERS', payload: {pageParams:{currentPage: page}}})
    }
    onRecordsPerPageChange = (recordsPerPage: any) => {
        this.props.dispatch({type: 'GET_USERS', payload: {pageParams:  {recordsPerPage: recordsPerPage, currentPage: 1,}}})
    }
    onQuery = () => {
        this.props.dispatch({type: 'GET_USERS', payload: {pageParams:{currentPage: 1}}})
    }
    onAddUser = () => {
        this.openDialog()
    }
    openDialog = () => {
        this.setState({
            open: true
        })
    }
    closeDialog = () =>{
        this.setState({
            open: false,
            addUserFormErrors: {},
            addUserForm: defaultAddUserForm
        })
    }
    handleAddUserFormChange = (object: {name: string, value: any}) => {
        let {addUserForm} = this.state
        let newState = {
            ...this.state,
            addUserForm: {
                ...addUserForm,
                [object.name]: object.value
            }
        }
        this.setState(newState)
    }
    validateUserForm = () => {
        let {intl} = this.props
        let errors : {[key: string] : string} = {}
        let {loginNo, password, name, phoneNo} = this.state.addUserForm
        let emailPattern = /^([A-Za-z0-9_\-.\u4e00-\u9fa5])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,8})$/;

        // 邮箱
        if(!loginNo) {
            errors['loginNo'] = intl.formatMessage({id: 'emailNotNull'})
        }else if( !emailPattern.test(loginNo)){
            errors['loginNo'] = intl.formatMessage({id: 'emialNotCorrect'})
        }
        // 密码
        if(!password || password.length < 6){
            errors['password'] = intl.formatMessage({id: 'passwordLessThan6'})
        }
        // 姓名
        if(!name){
            errors['name'] = intl.formatMessage({id: 'nameNotNull'})
        }
        // 手机号码
        if(!/^(\d|-)*$/.test(phoneNo || '')){
            errors['phoneNo'] = intl.formatMessage({id: 'phoneNotCorrect'})
        }

        this.setState({
            addUserFormErrors: errors
        })

        if(Object.keys(errors).length > 0){
            return false
        }else {
            return true
        }

    }
    addUserConfirm = () =>{
        if(!this.validateUserForm()){
            return
        }
        this.closeDialog()
        let data = {...this.state.addUserForm}
        let {password} = data
        data['password'] = md5(password + SALT_STRING)

        this.props.dispatch({type: 'USER_CHANGE', payload: {data: data, changeType: 'add'}})
    }

    public render() {
        return (
            <div className="users">
                <UserFilters role={this.props.role}
                             chainType={this.props.chainType}
                             storeList={this.props.storeList}
                             userFilter={this.props.userFilter}
                             handleFilterChange={this.handleFilterChange}
                             onClearFilter={this.clearFilter}
                             onConfirm={this.onQuery}
                             onAddUser={this.onAddUser}
                />
                <UserList list={this.props.userList}
                          chainType={this.props.chainType}
                          storeList={this.props.storeList}/>

                <Pagination total={this.props.total}
                            currentPage={this.props.currentPage}
                            recordsPerPage={this.props.recordsPerPage}
                            onPageChange={this.onPageChange}
                            onRecordsPerPageChange={this.onRecordsPerPageChange}/>

                <CustomDialog open={this.state.open}
                                   title="新增员工"
                                   content={<AddUserModal role={this.props.role}
                                                          errors={this.state.addUserFormErrors}
                                                          handleChange={this.handleAddUserFormChange}
                                                          formData={this.state.addUserForm}
                                                          chainType={this.props.chainType}
                                                          storeList={this.props.storeList}/>}
                                    onConfirm={this.addUserConfirm}
                                   handleClose={this.closeDialog}/>
            </div>
        );
    }
}

export default injectIntl(connect((state: reducerStoreType) => {
    return {
        chainType: state.merchant.merchantInfo.chainType,
        userList:state.users.userList,
        storeList: state.merchant.storeList,
        userFilter: state.users.userFilters,
        total: state.users.total,
        currentPage: state.users.currentPage,
        recordsPerPage: state.users.recordsPerPage,
        role: state.app.userInfo ? state.app.userInfo.role : ROLES.NONE,
    }
})(Users))
